/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import {
  GetComplianceReviewFailResponseData,
  GetComplianceReviewSuccessResponseData,
} from "~/features/myAccount/types";

const isLatestReviewAvailable = (
  resData: GetComplianceReviewSuccessResponseData | GetComplianceReviewFailResponseData,
): resData is GetComplianceReviewSuccessResponseData => {
  return !!(resData as GetComplianceReviewSuccessResponseData)?.id;
};

export default isLatestReviewAvailable;
